import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import AppNavbar from "../../components/shared/AppNavbar/AppNavbar";
// import StarFioFid from "../../images/StarFioFid.svg";
import PageHeader from "../../components/common/PageHeader/PageHeader";
import { LoyaltyArticlesList } from "../../components/home/ArticlesDiscountSection/LoyaltyArticlesList/LoyaltyArticlesList";
import AppLoading from "../../components/shared/Loaders/HomeLoading/AppLoading";
import { useConfig } from "../../context/ConfigContext";
import EmptyIcon from "../../images/EmptyIcon.svg";
import {
  LoyaltyArticle,
  RestaurantArticlesWithDiscount
} from "../../interfaces/loyality.interface";
import { loyalityApi } from "../../services/loyalityApi";
import { RootState } from "../../store/rootState";
import { getIcon, IconType } from "../../theme/icons";
import {
  transformToLoyaltyItems
} from "../../utils/loyaltyUtils";
import "./RestaurantFioFidPage.scss";

export default function RestaurantFioFidPage() {
  const isPhone = window.innerWidth <= 768;
  const { config } = useConfig();
  const navigate = useNavigate();
  const { restaurantId } = useParams();
  const userInfo = useSelector((state: RootState) => state.auth.userInfo);
  const selectedRestaurant = useSelector((state: RootState) => state.shop.selectedRestaurant);

  const [restaurantFilter, setRestaurantFilter] = useState("");
  const [restaurantArticles, setRestaurantArticles] = useState<RestaurantArticlesWithDiscount | null>(null);
  const [loading, setLoading] = useState<boolean>(true);
  const [maxPoints, setMaxPoints] = useState<number>(0);
  const [userProgress, setUserProgress] = useState<number>(0);
  const [missingPoints, setMissingPoints] = useState<number>(0);
  const [loyaltyArticles, setLoyaltyArticles] = useState<LoyaltyArticle[] | null>([]);

  useEffect(() => {
    const fetchArticles = async () => {
      try {
        setLoading(true);
        const response = await loyalityApi.getRestaurantArticlesWithDiscount(
          restaurantId || "0",
          userInfo?.qrCodeValue
        );

        const { result } = response.data;
        if (result?.cartRewardRule) {
          result.cartRewardRule.rewardDiscountType =
            result.cartRewardRule.rewardDiscountType ?? 0;
        }

        setRestaurantArticles(result);

        const userLoyaltyPoints = result?.loyaltyClient?.loyaltyPoints || 0;

        if (result?.articleRewardRules) {
          const lastArticle =
            result?.articleRewardRules?.[result.articleRewardRules.length - 1];

          setMaxPoints(lastArticle?.rewardTotalPtRequired || 0);
          const percentageUserPoints =
            (userLoyaltyPoints / lastArticle?.rewardTotalPtRequired || 0) * 100;
          setUserProgress(
            percentageUserPoints > 100 ? 100 : percentageUserPoints
          );

          const firstBigArticle = result?.articleRewardRules?.find(
            (reward) => reward.rewardTotalPtRequired > userLoyaltyPoints
          );

          setMissingPoints(
            Math.max(
              0,
              (firstBigArticle?.rewardTotalPtRequired || 0) - userLoyaltyPoints
            )
          );

          const loyaltyItems = transformToLoyaltyItems(
            result.articleRewardRules,
            userLoyaltyPoints
          );
          setLoyaltyArticles(loyaltyItems);
        }
      } catch (error) {
        setLoyaltyArticles([]);
        console.error("Error fetching articles:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchArticles();
  }, []);

  const remiseMessage =
    restaurantArticles?.cartRewardRule?.rewardDiscountType === 0
      ? `${restaurantArticles?.cartRewardRule?.rewardDiscountValue}%`
      : `${restaurantArticles?.cartRewardRule?.rewardDiscountValue?.toFixed(2)} €`;

  const message = ` bénéficier d’une réduction de ${remiseMessage} contre ${restaurantArticles?.cartRewardRule?.rewardTotalPtRequired} points de fidélité `;

  return (
    <div className="restaurant-fiofid">
      <AppNavbar
        setRestaurantFilter={setRestaurantFilter}
        restaurantFilter={restaurantFilter}
      />
      <PageHeader
        title="Restaurants"
        subtitle
        backAction={() => navigate(-1)}
      />

      <div className="restaurant-header">
        {loading ? (
          <div className="restaurant-content">
            <AppLoading />
          </div>
        ) : (
          <div className="restaurant-content">
            <div className="restaurant-content__wrapper">
              <div className="restaurant-card fl_col">
                <div className="restaurant-content-wrapper fl_col gp20">
                  <div className="restaurant-card__info">
                    <div className="fl_row jc_s ai_c">
                      <p className="restaurant-card__name">
                        {restaurantArticles?.restaurant?.name}
                      </p>
                      <div className="restaurant-card__info fl_row">
                        <p className="restaurant-card__points fl_row ai_c">
                          {restaurantArticles?.loyaltyClient?.loyaltyPoints}
                        </p>
                        {/* <StarFioFid color="red" /> */}
                        {restaurantArticles?.loyaltyClient &&
                          getIcon(IconType.StarFioFid, {
                            color: config?.primaryColor,
                          })}
                      </div>
                    </div>
                  </div>
                  {!restaurantArticles?.cartRewardRule &&
                    restaurantArticles?.loyaltyClient && (
                      <div className="fl_col gp20">
                        <div className="progress">
                          <div className="progress__container">
                            <span
                              className="progress__bar"
                              style={{ width: `${userProgress}% ` }}
                            ></span>
                          </div>
                          <div className="progress-dots fl_row">
                            {restaurantArticles?.articleRewardRules?.map(
                              (article) => {
                                const percentage =
                                  (article.rewardTotalPtRequired / maxPoints) *
                                  100;
                                return (
                                  <div
                                    key={article.rewardTotalPtRequired}
                                    style={{
                                      left: `calc(${percentage}% ${percentage === 100 ? "- 1.5%" : ""})`,
                                    }}
                                  >
                                    <span></span>
                                  </div>
                                );
                              }
                            )}
                          </div>
                        </div>
                        <p className="p12">
                          Plus que{" "}
                          <strong className="txt-orange">{`${missingPoints} points`}</strong>{" "}
                          pour la prochaine récompense.
                        </p>
                      </div>
                    )}
                </div>
              </div>
            </div>

            {restaurantArticles?.cartRewardRule ? (
              <div className="msg-noresult">
                <img width={"25px"} src={EmptyIcon} alt="" />
                <p>{message}</p>
              </div>
            ) : (
              <div className="restaurant-offres">
                {selectedRestaurant && (
                  <LoyaltyArticlesList
                    rewards={loyaltyArticles || []}
                    itemsPerRow={4}
                    scrollDirection={'vertical'}
                    restaurant={selectedRestaurant}
                    onPressViewAll={() => { }}
                  />
                )}
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
}
